var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EventApplication',{attrs:{"action":"daliyReview","title":"데일리 리뷰 통계","yAxisTitle":"리뷰수","dailyCount":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }